import { useState } from 'react';
import { supabase } from '@/lib/supabase';

export default function Auth({ onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleGoogleSignIn = async () => {
    setLoading(true);
    setError('');
    try {
      const { error: oauthError } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: { redirectTo: window.location.origin },
      });
      if (oauthError) throw oauthError;
      // Browser redirects to Google, then back — onAuthStateChange handles the rest
    } catch (err) {
      setError('Sign-in failed. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4"
         style={{ background: '#FFFEF9' }}>

      {/* YOU Logo */}
      <div className="flex items-center gap-2 mb-6">
        <img src="/logo-book.png" alt="YOU" style={{ width: 52, height: 52, objectFit: 'contain' }} />
        <div>
          <img src="/logo-you-text.png" alt="YOU" style={{ height: 18, objectFit: 'contain', display: 'block' }} />
          <img src="/logo-subtitle.png" alt="Your Own Understanding" style={{ height: 10, objectFit: 'contain', display: 'block', marginTop: 2 }} />
        </div>
      </div>

      {/* Heading */}
      <h1 className="text-xl mb-1" style={{ fontFamily: "'Patrick Hand', cursive", fontWeight: 400, color: '#1A1A2E' }}>Sign in to YOU</h1>
      <p className="text-sm mb-8" style={{ color: '#555555' }}>
        So your pet never forgets you!
      </p>

      {/* Google Sign-In Button */}
      <button
        onClick={handleGoogleSignIn}
        disabled={loading}
        aria-label="Sign in with Google"
        className="flex items-center justify-center gap-3 w-full max-w-xs
                   rounded-xl px-6 py-4 transition-transform active:scale-95"
        style={{
          background: '#FFFFFF',
          border: '1.5px dashed #CCCCCC',
          cursor: loading ? 'not-allowed' : 'pointer',
          opacity: loading ? 0.7 : 1,
        }}
      >
        <svg width="20" height="20" viewBox="0 0 24 24">
          <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
          <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
          <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A10.96 10.96 0 001 12c0 1.77.42 3.44 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
          <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
        </svg>
        <span style={{ color: '#333', fontSize: '16px', fontWeight: 600 }}>
          {loading ? 'Signing in...' : 'Continue with Google'}
        </span>
      </button>

      {/* Error */}
      {error && (
        <div className="mt-4 px-4 py-3 rounded-lg text-sm"
             role="alert"
             style={{ background: 'rgba(255,138,138,0.1)', color: '#FF8A8A' }}>
          {error}
        </div>
      )}

      {/* Benefits */}
      <div className="mt-8 w-full max-w-xs rounded-xl p-4"
           style={{ background: '#FFFFFF', border: '1.5px dashed #CCCCCC', borderLeft: '3px solid #448AFF' }}>
        {[
          ['💾', 'Your XP and streak saved forever'],
          ['📱', 'Access from any device'],
          ['🐼', 'Watch your pet evolve through 10 stages!'],
        ].map(([icon, text]) => (
          <div key={text} className="flex items-center gap-2 mb-2 last:mb-0">
            <span>{icon}</span>
            <span className="text-xs" style={{ color: '#555555', fontSize: 14 }}>{text}</span>
          </div>
        ))}
      </div>

      {/* Terms */}
      <p className="mt-6 text-center px-4" style={{ fontSize: '11px', color: '#666666' }}>
        By continuing, you agree to our Terms of Service and Privacy Policy.
        Under 13? Get your parent's permission.
      </p>
    </div>
  );
}
